/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Paid_SuccessInputs */

const en_billing_paid_success = /** @type {(inputs: Billing_Paid_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment received — your subscription is updated.`)
};

const id_billing_paid_success = /** @type {(inputs: Billing_Paid_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran diterima — langganan kamu sudah diperbarui.`)
};

/**
* | output |
* | --- |
* | "Payment received — your subscription is updated." |
*
* @param {Billing_Paid_SuccessInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_paid_success = /** @type {((inputs?: Billing_Paid_SuccessInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Paid_SuccessInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_paid_success(inputs)
	return en_billing_paid_success(inputs)
});